import React from "react";
import cx from "clsx";
import styles from "./logo.module.scss";
import LogoImg from "./logo.svg";

type Props = {};

export const Logo: React.FC<Props> = () => {
  return (
    <div className={cx("text-nowrap", styles.brandContainer)}>
      <img src={LogoImg} width="24" alt="regie logo" />
      <span className={styles.brandName}>regie.ai</span>
    </div>
  );
};
